// extracted by mini-css-extract-plugin
module.exports = {"Metrics":"snapshot_Metrics__JvWMt","MetricsLi":"snapshot_MetricsLi__HXZmB","metricsContainer":"snapshot_metricsContainer__d4bko","imageContainer":"snapshot_imageContainer__8n1ib"};